import axios from 'axios';
import { push } from 'connected-react-router';
import { authHeader } from "helpers/authHeader";
import { SubmissionError } from "redux-form";

export const INITIALIZED = "INITIALIZED";
export const initialized = () => ({
    type: INITIALIZED
});

export const SAVE_INITIAL_APPLICATION_REQUEST = "SAVE_INITIAL_APPLICATION_REQUEST";
export const SAVE_INITIAL_APPLICATION_SUCCESS = "SAVE_INITIAL_APPLICATION_SUCCESS";
export const SAVE_INITIAL_APPLICATION_FAILURE = "SAVE_INITIAL_APPLICATION_FAILURE";

const saveInitialApplicationRequest = () => ({
    type: SAVE_INITIAL_APPLICATION_REQUEST
});

export const STORE_BUSINESS_QUALIFICATION = 'STORE_BUSINESS_QUALIFICATION';

export const setBusinessQualifiesFor = (payload)=> ({
    type: STORE_BUSINESS_QUALIFICATION,
    payload
});

export const RESET_BUSINESS_QUALIFICATION = 'RESET_BUSINESS_QUALIFICATION';

export const resetBusinessQualifiesFor = () => ({
    type: RESET_BUSINESS_QUALIFICATION
});

// const saveInitialApplicationFailure = (payload) => ({
//     type: SAVE_INITIAL_APPLICATION_FAILURE,
//     payload
// });

const saveInitialApplicationSuccess = (payload) => ({
    type: SAVE_INITIAL_APPLICATION_SUCCESS,
    payload
});

export const saveInitialApplication = ( data ) => dispatch => {
    dispatch(saveInitialApplicationRequest());
    return axios('/lead', {
        method: 'POST',
        data
    }).then(response => {
        dispatch(saveInitialApplicationSuccess(response.data));        
    });
};


export const SAVE_BIZ_INFO_REQUEST = "SAVE_BIZ_INFO_REQUEST";
export const SAVE_BIZ_INFO_SUCCESS = "SAVE_BIZ_INFO_SUCCESS";
export const SAVE_BIZ_INFO_FAILURE = "SAVE_BIZ_INFO_FAILURE";

const saveBusinessInfoRequest = () => ({
    type: SAVE_BIZ_INFO_REQUEST
});

// const saveBusinessInfoFailure = (payload) => ({
//     type: SAVE_BIZ_INFO_FAILURE,
//     payload
// });

const saveBusinessInfoSuccess = (payload) => ({
    type: SAVE_BIZ_INFO_SUCCESS,
    payload
});

export const saveBusinessInfo = businessInfo => (dispatch, getState) => {
    dispatch(saveBusinessInfoRequest());
	let state = getState();
	let loanApplicationId = state.app.loanApplication ? state.app.loanApplication.id : null;
	if(loanApplicationId !== null){
		return axios(`/loan-aplication/${loanApplicationId}`, {
			method: 'PUT',
			headers: authHeader(),
			data: businessInfo
		}).then(response => {
			dispatch(saveBusinessInfoSuccess(response.data));
			return response.data;
		});
	}
};

export const SAVE_OWNERS_INFO_REQUEST = "SAVE_OWNERS_INFO_REQUEST";
export const SAVE_OWNERS_INFO_SUCCESS = "SAVE_OWNERS_INFO_SUCCESS";
export const SAVE_OWNERS_INFO_FAILURE = "SAVE_OWNERS_INFO_FAILURE";

const saveOwnersInfoRequest = () => ({
    type: SAVE_OWNERS_INFO_REQUEST
});

const saveOwnersInfoFailure = (payload) => ({
    type: SAVE_OWNERS_INFO_FAILURE,
    payload
});

const saveOwnersInfoSuccess = (payload) => ({
    type: SAVE_OWNERS_INFO_SUCCESS,
    payload
});

export const saveOwnersInfo = ownersInfo => (dispatch, getState) => {
	let state = getState();
	let loanApplicationId = state.app.loanApplication ? state.app.loanApplication.id : null;
    dispatch(saveOwnersInfoRequest());
    return axios(`/loan-aplication/${loanApplicationId}`, {
		method: 'PUT',
        headers: authHeader(),
        data: ownersInfo
    }).then(response => {
        dispatch(saveOwnersInfoSuccess(response.data));
        return response.data;
    }).catch(error => {
        const { data } = error.response;
        dispatch(saveOwnersInfoFailure(data));
        if (data.hasOwnProperty('error_code')) {
            if ( data.error_code === 'FORM_ERROR' ) {
				throw new SubmissionError({
					...data.errors,
					_error: data.errors.GLOBAL,
				})
            }
        } else {
			if(data.message){
				throw new SubmissionError({
					_error: data.message
				});
			}
        }
        throw error;
    })
};

export const SAVE_LOAN_INFO_REQUEST = "SAVE_LOAN_INFO_REQUEST";
export const SAVE_LOAN_INFO_SUCCESS = "SAVE_LOAN_INFO_SUCCESS";
export const SAVE_LOAN_INFO_FAILURE = "SAVE_LOAN_INFO_FAILURE";

const saveLoanInfoRequest = () => ({
    type: SAVE_LOAN_INFO_REQUEST
});

// const saveLoanInfoFailure = (payload) => ({
//     type: SAVE_LOAN_INFO_FAILURE,
//     payload
// });

const saveLoanInfoSuccess = (payload) => ({
    type: SAVE_LOAN_INFO_SUCCESS,
    payload
});

export const saveLoanInfo = data => (dispatch, getState) => {
	let state = getState();
	let loanApplicationId = state.app.loanApplication ? state.app.loanApplication.id : null;
    dispatch(saveLoanInfoRequest());
	delete data.files;
    return axios(`/loan-aplication/${loanApplicationId}`, {
		method: 'PUT',
        headers: authHeader(),
        data,
    }).then(response => {
        dispatch(saveLoanInfoSuccess(response.data));
        return response.data;
    });
};


export const FETCH_STATES_REQUEST = "FETCH_STATES_REQUEST";
export const FETCH_STATES_SUCCESS = "FETCH_STATES_SUCCESS";
// export const FETCH_STATES_FAILURE = "FETCH_STATES_FAILURE";

const fetchStatesRequest = () => ({
    type: FETCH_STATES_REQUEST
});

// const fetchStatesFailure = (payload) => ({
//     type: FETCH_STATES_FAILURE,
//     payload
// });

const fetchStatesSuccess = (payload) => ({
    type: FETCH_STATES_SUCCESS,
    payload
});

export const fetchStates = () => dispatch => {
    dispatch(fetchStatesRequest());
    return axios('/state', {
        method: 'GET',
        headers: authHeader()
    })
        .then(response => {
            dispatch(fetchStatesSuccess(response.data));
        });
};

export const FETCH_LEGAL_ENTITY_TYPES_REQUEST = "FETCH_LEGAL_ENTITY_TYPES_REQUEST";
export const FETCH_LEGAL_ENTITY_TYPES_SUCCESS = "FETCH_LEGAL_ENTITY_TYPES_SUCCESS";
export const FETCH_LEGAL_ENTITY_TYPES_FAILURE = "FETCH_LEGAL_ENTITY_TYPES_FAILURE";

const fetchLegalEntityTypesRequest = () => ({
    type: FETCH_LEGAL_ENTITY_TYPES_REQUEST
});

// const fetchLegalEntityTypesFailure = (payload) => ({
//     type: FETCH_LEGAL_ENTITY_TYPES_FAILURE,
//     payload
// });

const fetchLegalEntityTypesSuccess = (payload) => ({
    type: FETCH_LEGAL_ENTITY_TYPES_SUCCESS,
    payload
});

export const fetchLegalEntityTypes = () => dispatch => {
    dispatch(fetchLegalEntityTypesRequest());
    return axios('/legal-entity-type', {
        method: 'GET',
        headers: authHeader()
    })
    .then(response => {
        dispatch(fetchLegalEntityTypesSuccess(response.data));
    });
};


export const SAVE_APPLICATION_REQUEST = "SAVE_APPLICATION_REQUEST";
export const SAVE_APPLICATION_SUCCESS = "SAVE_APPLICATION_SUCCESS";
export const SAVE_APPLICATION_FAILURE = "SAVE_APPLICATION_FAILURE";

const saveApplicationRequest = () => ({
    type: SAVE_APPLICATION_REQUEST
});

// const saveApplicationFailure = (payload) => ({
//     type: SAVE_APPLICATION_FAILURE,
//     payload
// });

const saveApplicationSuccess = (payload) => ({
    type: SAVE_APPLICATION_SUCCESS,
    payload
});

export const saveApplication = (data) => dispatch => {
    dispatch(saveApplicationRequest());

    if ( data.signature === null ) {
        throw new SubmissionError({
            _error: 'You must sign the application.'
        });
    }

    return axios('/loan-aplication/to-review', {
        method: "POST",
        headers: authHeader(),
        data
    }).then(response => {
        dispatch(saveApplicationSuccess(response.data));
        dispatch(push('/application/success'));
        return response.data;
    });
};

export const FETCH_PENDING_LOAN_APPLICATION_REQUEST = "FETCH_PENDING_LOAN_APPLICATION_REQUEST";
export const FETCH_PENDING_LOAN_APPLICATION_SUCCESS = "FETCH_PENDING_LOAN_APPLICATION_SUCCESS";
export const FETCH_PENDING_LOAN_APPLICATION_FAILURE = "FETCH_PENDING_LOAN_APPLICATION_FAILURE";
//export const UPDATE_PENDING_LOAN_APPLICATION = "UPDATE_PENDING_LOAN_APPLICATION";

const fetchPendingLoanApplicationRequest = () => ({
    type: FETCH_PENDING_LOAN_APPLICATION_REQUEST
});

const fetchPendingLoanApplicationSuccess = (payload) => ({
    type: FETCH_PENDING_LOAN_APPLICATION_SUCCESS,
    payload
});

//const fetchPendingLoanApplicationFailure = (payload) => ({
//	type: FETCH_PENDING_LOAN_APPLICATION_FAILURE,
//	payload
//});

export const fetchPendingLoanApplication = () => dispatch => {
	dispatch(fetchPendingLoanApplicationRequest());
	return axios.get("/loan-aplication/pending", {
        method: "GET",
        headers: authHeader()
    }).then(response => {		
		dispatch(fetchPendingLoanApplicationSuccess(response.data));
	})
};
//
//const updatePendingLoanApplication = (payload) => ({
//    type: UPDATE_PENDING_LOAN_APPLICATION,
//    payload
//});

export const UPLOAD_STATEMENT_REQUEST = "UPLOAD_STATEMENT_REQUEST";
export const UPLOAD_STATEMENT_SUCCESS = "UPLOAD_STATEMENT_SUCCESS";
// export const UPLOAD_STATEMENT_FAILURE = "UPLOAD_STATEMENT_FAILURE";

const uploadStatementRequest = (position) => ({
    type: UPLOAD_STATEMENT_REQUEST,
    position
});

// const uploadStatementFailure = (payload) => ({
//     type: UPLOAD_STATEMENT_FAILURE,
//     payload
// });

const uploadStatementSuccess = (payload, position) => ({
    type: UPLOAD_STATEMENT_SUCCESS,
    payload,
    position
});

export const uploadStatement = (application_id, data, position) => (dispatch) => {
    dispatch(uploadStatementRequest(position));
    return axios(`/loan-aplication/${application_id}/statement`, {
        method: "POST",
        headers: authHeader(),
        data
    }).then(response => {
        dispatch(uploadStatementSuccess(response.data, position));
        return response.data;
    });
};

export const DELETE_STATEMENT_REQUEST = "DELETE_STATEMENT_REQUEST";
export const DELETE_STATEMENT_SUCCESS = "DELETE_STATEMENT_SUCCESS";
// export const DELETE_STATEMENT_FAILURE = "DELETE_STATEMENT_FAILURE";

const deleteStatementRequest = (position) => ({
    type: DELETE_STATEMENT_REQUEST,
    position
});

// const deleteStatementFailure = (payload) => ({
//     type: DELETE_STATEMENT_FAILURE,
//     payload
// });

const deleteStatementSuccess = (payload, position) => ({
    type: DELETE_STATEMENT_SUCCESS,
    payload,
    position
});

export const deleteStatement = (id, position) => (dispatch, getState) => {
    dispatch(deleteStatementRequest(position));
	let state = getState();
	let loanApplicationId = state.app.loanApplication ? state.app.loanApplication.id : null;
    return axios(`/loan-aplication/${loanApplicationId}/statement/${id}`, {
        method: "DELETE",
        headers: authHeader()
    }).then(response => {
        dispatch(deleteStatementSuccess(response.data, position));
        return response.data;
    });
};


// WEBPACK FOOTER //
// ./src/actions/app.js